'use client'
import { useCart } from "@/contexts/CartContext";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect } from "react";
import { BsCart4 } from "react-icons/bs";
import { useUser } from "@/contexts/UserContext";
import { Navbar, NavbarContent, NavbarItem, Badge, NavbarMenu, NavbarMenuItem, NavbarMenuToggle, Dropdown, DropdownMenu, DropdownItem, DropdownTrigger } from "@nextui-org/react";
import { usePathname, useRouter } from "next/navigation";
import logo from "@/public/images/logowtbg.svg"
import SubscribeBtn from "./SubscribeBtn";
import AccountBtn from "./AccountBtn";
import { MdArrowDropDown } from "react-icons/md";

const activeLinkClasses = "text-amber-500 border-b-2 border-amber-500";
const Header = () => {
  const { cart, setCart } = useCart();
  const { signedIn, setSignedIn } = useUser();
  const router = useRouter();
  const pathName = usePathname();
  const menuItems = [
    {
      name: "HOME",
      link: "/",
    },
    {
      name: "SHOP",
      link: "/products",
    },
    {
      name: "FRANCHISE",
      link: "/franchise",
    },
    {
      name: "VENDING",
      type: "dropdown",
      component: <VendingDropdown />,
      link: "/vendingservice",
    },
    {
      name: "VENDING",
      link: "/vendingservice",
      mobileOnly: true
    },
    {
      name: "EVENTS",
      link: "/events",
      mobileOnly: true
    },
    {
      name: "ABOUT",
      link: "/about",
    },
    {
      name: "CONTACT US",
      link: "/contact",
    },
  ]
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  useEffect(() => {
    setIsMenuOpen(false)
  }
    , [pathName])
  return (
    <Navbar maxWidth="2xl" className="xl:px-8 py-3" isBlurred={false} isBordered isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}>
      <NavbarContent className="xl:hidden" justify="start">
        <NavbarMenuToggle />
      </NavbarContent>

      <NavbarContent className="pr-3" justify="center">
        <NavbarItem className="sm:hidden">
          <Link href="/" className="flex items-center gap-2">
            <Image
              src={logo}
              alt="logo"
              width={40}
              height={40}
              className="w-[40px] h-[40px] drop-shadow-xl rounded-full"
            />
          </Link>
        </NavbarItem>
        <NavbarItem className="sm:flex xl:mr-4 hidden">
          <Link href="/" className="flex items-center gap-2">
            <Image
              src={logo}
              alt="logo"
              width={256}
              height={256}
              className="w-[54px] h-[54px] drop-shadow-xl rounded-full"
            />
            <h1 className="flex flex-col">
              <span className="text-[1.25rem] font-semibold"
              >CHAIVIO</span>
              <span className="text-base text-[0.9rem]"
              >Give Life More Flavors</span>
            </h1>
          </Link>
        </NavbarItem>

      </NavbarContent>

      <NavbarContent className="hidden xl:flex gap-4" justify="center">

        {
          menuItems.map((item, index) => {
            if (item.type != "dropdown" && !item.mobileOnly)
              return (
                <NavbarItem key={`${item}-${index}`}>
                  <Link
                    className={`text-lg ${pathName === item.link ? activeLinkClasses : ""}`}
                    href={item.link}
                  >
                    {item.name}
                  </Link>
                </NavbarItem>)
            else if (item.type === "dropdown")
              return (
                <NavbarItem key={`${item}-${index}`}>
                  {item.component}
                </NavbarItem>)
          }
          )
        }

      </NavbarContent>

      <NavbarContent justify="end" className="gap-6">
        <NavbarItem className="xl:flex hidden">
          <SubscribeBtn />
        </NavbarItem>
        <NavbarItem>
          <Link href="/cart" className={`flex items-center gap-2 ${pathName === "/cart" ? "text-amber-500" : ""}`}
          >
            <Badge content={cart.length} color="success" size="lg">
              <BsCart4 size={32} />
            </Badge>
          </Link>
        </NavbarItem>
        <NavbarItem>
          <AccountBtn signedIn={signedIn} setSignedIn={setSignedIn} pathName={pathName} router={router} />
        </NavbarItem>
      </NavbarContent>

      <NavbarMenu className="gap-8 pt-[6rem]">
        {menuItems.map((item, index) => {
          if (item.type != "dropdown")
            return (
              <NavbarMenuItem key={`${item}-${index}`} >
                <Link
                  className={`w-full text-xl md:text-2xl ${pathName === item.link ? activeLinkClasses : ""}`}
                  href={item.link}
                >
                  {item.name}
                </Link>
              </NavbarMenuItem>)
        }
        )}
        <NavbarMenuItem className="text-2xl">
          <SubscribeBtn />
        </NavbarMenuItem>
      </NavbarMenu>

    </Navbar>)
}

export default Header;

const VendingDropdown = () => {
  const router = useRouter()
  const pathName = usePathname();
  return (
    <Dropdown className="w-fit mx-0" classNames={{
      trigger: "w-fit mx-0",
    }}>
      <DropdownTrigger className="w-fit mx-0">
        <button className="flex gap-2 items-center w-fit"><span className={`text-lg ${pathName === "/vendingservice" || pathName === "/events" ? "text-amber-500 " + activeLinkClasses : ""}`}
        >{
            pathName === "/events" ? "EVENTS" : "VENDING"
          }</span><MdArrowDropDown /></button>
      </DropdownTrigger>
      <DropdownMenu>
        <DropdownItem key={0}
          onClick={() => {
            router.push("/vendingservice")
          }}
          className={`${pathName === "/vendingservice" ? "text-amber-500" : ""}`}
        >Vending Service</DropdownItem>
        <DropdownItem
          onClick={() => {
            router.push("/events")
          }} key={1}
          className={`${pathName === "/events" ? "text-amber-500" : ""}`}
        >Book an Event</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
